const pathNames = {
    home: '/',
    main: '/main/',
    login: '/login/',
    passwordReset: '/password-reset/',
    passwordResetPin: '/password-reset-pin/',
    forgotResetPassword: '/forgot-reset-password/',
    payment: '/payment/',
    newChangePassword: '/new-change-password/',
    changePassword: '/change-password/',
    register: '/register/',
    overview: '/overview/',
    portfolio: '/portfolio/',
    equity: '/equity/:ticker?/',
    announcements: '/announcements/',
    comparative: '/comparative/',
    technicalScan: '/technicalScan/',
    fourHundredFour: '/404/',
    DalalStreet: '/DalalStreet/',
    Dashboard: '/Dashboard/',
    TermsAndConditions: '/TermsAndConditions/',
};

export default pathNames;



// WEBPACK FOOTER //
// ./src/common/constants/pathNames.js